import IStoreState from "../store/IStoreState";

const defaultState: IStoreState = {
  csrf: '',
  isAuthenticated: false,
  user: '',
  wsid: '',
  loginTime: 0
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/reducers/authenticationInitialState.ts